import script from "./GalleryBase.vue?vue&type=script&lang=js"
export * from "./GalleryBase.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__